import React, { useState } from 'react';
import '../error/ErrorPage.css';
import { Button, CircularProgress, Grid, TextField } from '@mui/material';
import Select from 'react-select';
import man from '../../../assets/images/man.png';
import details from '../../../assets/images/details.jpg';
import woman from '../../../assets/images/woman.png';
import none from '../../../assets/images/none.png';
import { useLocation } from 'react-router-dom';
import { REACT_APP_SURVEY_ID, REACT_APP_SURVEY_ID_ER } from '../../../config';
import axios from 'axios';
import Invite from '../../../components/invite';
import Toast from '../../../components/toast/Toast';
import Snack from '../../../components/snack';

const CustomOptionAge = ({ innerProps, label, data }) => (
  <div
    {...innerProps}
    style={{ display: 'flex', padding: '10px', color: '#000' }}
  >
    {label}
  </div>
);
const CustomOption = ({ innerProps, label, data }) => (
  <div
    {...innerProps}
    style={{
      display: 'flex',
      padding: '10px',
      color: '#000',
    }}
  >
    <img
      src={data.image}
      alt={label}
      style={{ width: '24px', marginRight: '8px' }}
    />
    {data?.label}
  </div>
);

const CustomSingleValueAge = ({ innerProps, label, data }) => (
  <div {...innerProps} style={{ display: 'flex', color: '#000' }}>
    <div style={{ color: '#000' }}>{data.label}</div>
  </div>
);
const CustomSingleValue = ({ innerProps, label, data }) => (
  <div {...innerProps} style={{ display: 'flex', color: '#000' }}>
    <img
      src={data.image}
      alt={label}
      style={{ width: '24px', marginRight: '8px' }}
    />
    <div style={{ color: '#000' }}>{data.label}</div>
  </div>
);
export default function Thankyou() {
  const handleClose = ({ final }) => {
    // window.open('', '_blank', '');
    // window.close();
    // Open a new blank tab and close the current tab
    // var customWindow = window.open('', '_blank', '');
    // customWindow.close();
    // console.log('first');
  };
  const { state: finalStep } = useLocation();
  const { state } = finalStep;
  const { data } = finalStep;
  const { type } = finalStep;
  const { survey_id: initialId } = finalStep;
  const member_id = state && state?.member_id;
  const [open, setOpen] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email1, setEmail1] = useState('');
  const [email2, setEmail2] = useState('');
  const [email3, setEmail3] = useState('');
  const [email1valid, setEmail1valid] = useState('');
  const [email2valid, setEmail2valid] = useState('');
  const [email3valid, setEmail3valid] = useState('');
  const [text, setEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [showDetail, setShowDetail] = useState(false);
  const [selectedAgeIndex, setSelectedAgeIndex] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const handleCloseSnack = () => {
    setOpenSnack(false);
  };

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const isValid = emailRegex?.test(text);
  const options = [
    {
      label: 'Male',
      image: man,
    },
    {
      label: 'Female',
      image: woman,
    },
    {
      label: 'Other',
      image: none,
    },
  ];
  const ages = [
    {
      label: '20-29',
      image: null,
    },
    {
      label: '30-39',
      image: null,
    },
    {
      label: '40-49',
      image: null,
    },
    {
      label: '50+',
      image: null,
    },
  ];
  const [toastState, setToastState] = React.useState({
    open: false,
  });
  const handleCloseToast = () => {
    setToastState({
      open: !toastState.open,
    });
  };

  const submit = async () => {
    const data =
      survey_id_manage === initialId
        ? {
            project_id: initialId,
            member_id: member_id,
            agegroup: selectedAgeIndex?.label,
            gender: selectedOption?.label,
            email: text,
          }
        : { project_id: initialId, member_id: member_id, email: text };
    setLoading(true);
    await axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/reports/sendIndividualReportLink`,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: data,
    })
      .then(function (response) {
        // console.log(response);
        // console.log(state);
        console.log(response);
        // window.scrollTo(0, document.body.scrollHeight);
        handleCloseToast();
        setLoading(false);

        // window.location.reload();
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const handleChange = async (option) => {
    setSelectedOption(option);
  };
  const handleEmail = (e) => {
    setEmail(() => e.target.value);
  };
  const handleChangeAge = async (option) => {
    setSelectedAgeIndex(option);
  };
  const survey_id_manage =
    initialId === REACT_APP_SURVEY_ID
      ? REACT_APP_SURVEY_ID
      : REACT_APP_SURVEY_ID_ER;
  return (
    <div className="error-page">
      <h1>Thank you!</h1>
      {initialId === REACT_APP_SURVEY_ID ? (
        <p style={{ width: '80%' }}>
          You have completed taking the survey. Your response has been recorded
          , To receive your KAYA Wellbeing Report including the links below
          please add your email address here:
        </p>
      ) : (
        <p>
          {' '}
          You have completed taking the survey. Your response has been recorded
          , Thank you
        </p>
      )}
      {!(initialId === REACT_APP_SURVEY_ID) && (
        <Button
          variant="contained"
          onClick={handleClose}
          sx={{
            fontSize: '16px',
            fontWeight: 500,
            padding: '8px 30px',
            textTransform: 'capitalize',
            backgroundColor: '#007bff',
            '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
              backgroundColor: '#007bff',
            },
          }}
        >
          Close
        </Button>
      )}
      {initialId === REACT_APP_SURVEY_ID ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '30px',
            width: '100%',
          }}
          className="justify-center p-16"
        >
          <div
            className="sbtop"
            style={{
              display: 'flex',
              widtht: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '50px',
              fontSize: '20px',
            }}
          >
            <div
              className={`dropdown-select ${
                survey_id_manage === initialId ? '' : 'dropdown-select2'
              } textinput-t flex gap-2`}
              style={{
                width: survey_id_manage === initialId ? '80%' : '60%',
              }}
            >
              <Grid container spacing={2}>
                {/* {survey_id_manage === initialId && (
                    <Grid item sm={12} md={6} lg={3} className="w-full">
                      <TextField
                        label="Enter Company Name"
                        fullWidth
                        size="medium"
                        sx={{
                          '& input .internal-autofill-selected ': {
                            backgroundColor: '0 0 0 1000px white inset',
                            color: '#000',
                          },
                        }}
                        onChange={handleCompanyName}
                        style={{
                          flex: 1,
                          color: '#000',
                          fontSize: '18px',
                          fontWeight: '400px',
                        }}
                        variant="outlined"
                      />
                    </Grid>
                  )} */}
                {survey_id_manage === initialId && (
                  <Grid item sm={12} md={6} lg={4} className="w-full">
                    <Select
                      options={ages}
                      value={selectedAgeIndex}
                      placeholder="Select Age Group"
                      isSearchable={false}
                      onChange={handleChangeAge}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.label}
                      components={{
                        Option: CustomOptionAge,
                        SingleValue: CustomSingleValueAge,
                      }}
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          display: 'flex',
                          minWidth: '100px',
                          height: '100%',
                          flex: 1,
                          minHeight: '51px',
                        }),
                      }}
                    />
                  </Grid>
                )}
                {survey_id_manage === initialId && (
                  <Grid item sm={12} md={6} lg={4} className="w-full">
                    <Select
                      options={options}
                      value={selectedOption}
                      placeholder="Select Gender"
                      isSearchable={false}
                      onChange={handleChange}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.label}
                      components={{
                        Option: CustomOption,
                        SingleValue: CustomSingleValue,
                      }}
                      style={{
                        display: 'flex',
                        minWidth: '100px',
                        height: '100%',
                        flex: 1,
                      }}
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          display: 'flex !important',
                          minWidth: '100px',
                          height: '100%',
                          flex: 1,
                          minHeight: '51px',
                        }),
                      }}
                    />
                  </Grid>
                )}
                <Grid
                  item
                  sm={12}
                  md={survey_id_manage === initialId ? 6 : 12}
                  lg={survey_id_manage === initialId ? 4 : 12}
                  className="w-full"
                >
                  <TextField
                    label="Enter your email address"
                    fullWidth
                    size={'medium'}
                    sx={{
                      '& input .internal-autofill-selected ': {
                        backgroundColor: '0 0 0 1000px white inset',
                        color: '#000',
                      },
                      '& .MuiInputLabel-root': {
                        zIndex: 0,
                      },
                    }}
                    onChange={handleEmail}
                    style={{
                      flex: 1,
                      color: '#000',
                      fontSize: '18px',
                      fontWeight: '400px',
                    }}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </div>
            <div
              style={{ display: 'flex', gap: '20px' }}
              className={`btn-container btn-container2 ${
                survey_id_manage === initialId
                  ? 'btn-container21'
                  : 'btn-container3'
              }`}
            >
              <Button
                endIcon={loading && <CircularProgress size={'20px'} />}
                onClick={submit}
                className="signupCVbtnSign w-max flex self-end"
                type="submit"
                variant="contained"
                style={{
                  backgroundColor: !isValid ? '' : '#D0ECE6',
                  color: '#000',
                }}
                disabled={!isValid}
                sx={{
                  fontSize: '16px',
                  fontWeight: 500,
                  padding: '8px 30px',
                  textTransform: 'capitalize',
                  color: '#000',
                  backgroundColor: '#D0ECE6',
                  '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                    backgroundColor: !isValid ? '' : '#D0ECE6',
                  },
                }}
              >
                Send Report
              </Button>
              {initialId === REACT_APP_SURVEY_ID && (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!isValid}
                  className="signupCVbtnSign2 mt-6 mb-4 w-max flex self-end"
                  style={{
                    backgroundColor: !isValid ? '' : '#D0ECE6',
                    color: '#000',
                  }}
                  onClick={() => setOpen(true)}
                  sx={{
                    fontSize: '16px',
                    fontWeight: 500,
                    padding: '8px 30px',
                    textTransform: 'capitalize',
                    color: '#000',
                    backgroundColor: '#D0ECE6',
                    '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                      backgroundColor: !isValid ? '' : '#D0ECE6',
                    },
                  }}
                >
                  Refer your friends
                </Button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <Invite
        loading={loading}
        setLoading={setLoading}
        open={open}
        setOpen={setOpen}
        setOpenSnack={setOpenSnack}
        project_id={initialId}
        member_id={member_id}
        email={text}
        email1={email1}
        email2={email2}
        email3={email3}
        email1valid={email1valid}
        email2valid={email2valid}
        email3valid={email3valid}
        setEmail1={setEmail1}
        setEmail2={setEmail2}
        setEmail3={setEmail3}
        setEmail1valid={setEmail1valid}
        setEmail2valid={setEmail2valid}
        setEmail3valid={setEmail3valid}
        agegroup={selectedAgeIndex?.label}
        gender={selectedOption?.label}
        company_name={companyName}
      />
      <Snack
        open={openSnack}
        color={'success'}
        onClose={handleCloseSnack}
        message="Invitation sent successfully"
      />
      <Toast
        password
        handleClose={handleCloseToast}
        state={toastState}
        error="A copy of the report has been emailed to you."
      />
    </div>
  );
}
